import * as Status from '../../constants/status';
import * as Role from '../../constants/role';
import moment from 'moment';

/**
 * Default date types for filtering NSIRs
 */
export const DEFAULT_DATE_TYPES = [
  'DATA_CRIACAO',
  'DATA_DIGITACAO',
  'DATA_EXECUTADA_GDIS',
  'DATA_INSPECAO',
  'DATA_VENCIMENTO',
];

/**
 * Default status filter for NSIRs
 */
export const DEFAULT_STATUS = [
  Status.AGUARDANDO_INSPECAO,
  Status.EM_INSPECAO,
  Status.INSPECAO_FINALIZADA,
  Status.INSPECAO_ENVIADA_PARCIAL,
  Status.AGUARDANDO_DIGITACAO,
  Status.EM_DIGITACAO,
  Status.DIGITACAO_FINALIZADA,
];

/**
 * Default filter configuration
 */
export const getDefaultFilter = (authDataEmail, isUsuarioUsoMuto) => ({
  inicio: moment().subtract(1, 'year').startOf('year').valueOf(),
  fim: moment().endOf('day').valueOf(),
  status: DEFAULT_STATUS,
  dateTypes: DEFAULT_DATE_TYPES,
  tipoServicos: isUsuarioUsoMuto(authDataEmail) ? ["374aa79b-0ce2-4b45-9c55-ae20ec5c5e27"] : null,
});

/**
 * Status options based on user role
 */
export const getStatusOptionsByRole = (userRole) => {
  if (userRole === Role.INSPETOR) {
    return [
      {'id': Status.AGUARDANDO_INSPECAO, nome: 'Aguardando Inspeção'},
      {'id': Status.INSPECAO_EM_ENVIO, nome: 'Inspeção em Envio'},
      {'id': Status.EM_INSPECAO, nome: 'Em Inspeção'},
      {'id': Status.INSPECAO_ENVIADA_PARCIAL, nome: 'Inspeção Enviada Parcial'},
      {'id': Status.INSPECAO_SYNC_ERROR, nome: 'Inspeção com Erro de Envio'},
      {'id': Status.ERRO_AO_ENVIAR_INSPECAO, nome: 'Erro ao enviar Inspeção'},
      {'id': Status.INSPECAO_FINALIZADA, nome: 'Inspeção Finalizada'},
      {'id': Status.AGUARDANDO_DIGITACAO, nome: 'Aguardando Digitação'},
      {'id': Status.EM_DIGITACAO, nome: 'Em Digitação'},
      {'id': Status.DIGITACAO_FINALIZADA, nome: 'Digitação Finalizada'},
      {'id': Status.EXECUTADA_GDIS, nome: 'Executada GDIS'}
    ];
  }
  
  if (userRole === Role.DIGITADOR) {
    return [
      {'id': Status.INSPECAO_FINALIZADA, nome: 'Inspeção Finalizada'},
      {'id': Status.AGUARDANDO_DIGITACAO, nome: 'Aguardando Digitação'},
      {'id': Status.EM_DIGITACAO, nome: 'Em Digitação'},
      {'id': Status.DIGITACAO_FINALIZADA, nome: 'Digitação Finalizada'},
      {'id': Status.EXECUTADA_GDIS, nome: 'Executada GDIS'}
    ];
  }
  
  return [
    {'id': Status.EM_CRIACAO, nome: 'Em Criação'},
    {'id': Status.AGUARDANDO_INSPECAO, nome: 'Aguardando Inspeção'},
    {'id': Status.INSPECAO_EM_ENVIO, nome: 'Inspeção em Envio'},
    {'id': Status.EM_INSPECAO, nome: 'Em Inspeção'},
    {'id': Status.INSPECAO_ENVIADA_PARCIAL, nome: 'Inspeção Enviada Parcial'},
    {'id': Status.INSPECAO_SYNC_ERROR, nome: 'Inspeção com Erro de Envio'},
    {'id': Status.ERRO_AO_ENVIAR_INSPECAO, nome: 'Erro ao enviar Inspeção'},
    {'id': Status.INSPECAO_FINALIZADA, nome: 'Inspeção Finalizada'},
    {'id': Status.AGUARDANDO_DIGITACAO, nome: 'Aguardando Digitação'},
    {'id': Status.EM_DIGITACAO, nome: 'Em Digitação'},
    {'id': Status.DIGITACAO_FINALIZADA, nome: 'Digitação Finalizada'},
    {'id': Status.EXECUTADA_GDIS, nome: 'Executada GDIS'}
  ];
};

/**
 * Dialog types for NSIRs management
 */
export const DIALOG_TYPES = {
  IMPORT: 'import',
  IMPORT_NSMPS: 'importNsmps',
  IMPORT_FINANCEIRO: 'importFinanceiro',
  IMPORT_DIGITADOR: 'importDigitador',
  EXPORT: 'export',
  EXPORT_EDIT: 'exportEdit',
  EXPORT_SERVICO: 'exportServico',
  EXPORT_FINANCEIRO: 'exportFinanceiro',
  EXPORT_DIGITADOR: 'exportDigitador',
  EXPORT_INSPECAO: 'exportInspecao',
  EXPORT_REPORT_USO_MUTUO: 'exportReportUsoMutuo',
  EXPORT_DIGITADOR_DIARIO: 'exportDigitadorDiario',
};

/**
 * File import error messages
 */
export const ERROR_MESSAGES = {
  INVALID_SHEET: "Planilha inválida. Por favor, utilize a planilha 'Planilha Importação' que se encontra na aba de Documentos!",
  INVALID_FILE: "Arquivo inválido. Por favor, utilize um arquivo válido para importar os serviços!",
  INVALID_DIGITADOR_SHEET: "Planilha inválida. Por favor, exporte a planilha de digitadores e utilize-a!",
  READ_ERROR: 'Erro ao abrir a planilha. Por favor, tente novamente!',
};

/**
 * Export confirmation messages
 */
export const EXPORT_MESSAGES = {
  NSIRS: 'Deseja exportar todas as NSIRs filtradas?',
  EDIT: 'Deseja exportar todas as NSIRs filtradas para edição?',
  SERVICO: 'Deseja exportar todos os serviços para as NSIRs filtradas?',
  INSPECAO: 'Deseja exportar as informações da inspeção para as NSIRs filtradas?',
  FINANCEIRO: 'Deseja exportar todas as NSIRs filtradas para financeiro?',
  DIGITADOR: 'Deseja exportar todas as NSIRs filtradas para digitadores?',
  USO_MUTUO: 'Deseja exportar todas as NSIRs filtradas para Uso Mútuo?',
  DIGITADOR_DIARIO: 'Deseja exportar o relatório de digitares diários para os últimos 7 dias?',
};

/**
 * Special email addresses for digitador diário export
 */
export const DIGITADOR_DIARIO_ALLOWED_EMAILS = [
  'vinicius_admin',
  'NUBIA CRISTINA RIGUEIRA SALGADO',
  'RAFAEL DIAS GARCIA'
];
